import { Box, Button, CardActions, CardContent, CardHeader, Dialog, DialogActions, DialogTitle, Divider, Grid, MobileStepper, Modal, Paper, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DatosGenerales from './formulario/DatosGenerales';
import ActividadesEconomicas from './formulario/ActividadesEconomicas';
import TotalSocios from './formulario/TotalSocios';
import Antecedentes from './formulario/Antecedentes';
import ProductosServicios from './formulario/ProductosServicios';
import ContactoComercial from './formulario/ContactoComercial';
import DatosPublicador from './formulario/DatosPublicador';

import { useNavigate } from 'react-router-dom';
import { validarEmail, validarTelefono } from '../lib/validate';
import toast from 'react-hot-toast';
import { CheckCircle, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Objetivos from './formulario/Objetivos';

const AgregarEmpresa = () => {
    const [paso, setPaso] = useState(0);
    const navigate = useNavigate();
    const [terminos, setTerminos] = useState(false);
    const [datosFormulario, setDatosFormulario] = useState({
        datos_generales: {
            nombre_empresa: '',
            nombre_comercial: '',
            descripcion: '',
            acronimo_empresa: '',
            figura_juridica_es: '',
            nombre_contacto: '',
            logotipo: '', // objeto File
            galeria: '', // array con objetos File
            calle: '',
            numero_ext: '',
            numero_int: '',
            codigo_postal: '',
            localidad: '',
            municipio: '',
            estado: '',
            geolocalizacion: '',
            telefono: '',
            whatsapp: '',
            email: '',
            pagina_web: '',
            facebook: '',
            instagram: '',
            tiktok: '',
            x_twitter: '',
            url_tienda: '',
        },
        objetivos: {
            proposito: '',
            factores: [],
            organizaciones: [],
            resultados: [],
            perspectivas: []
        },
        actividades_economicas: {
            giro_actividad: [],
            galeria_actividades: [], // array con objetos File
            galeria_productos_servicios: [[]], // array con arrays con objetos File
            galeria_unidades_produccion: [[]], // array con arrays con objetos File
            productos_servicios: [],
            unidades_produccion: [],

        },
        total_socios: {
            cant_socios_hombres: '',
            cant_socios_mujeres: '',
            cant_empleados_operarios: '',
            cant_empleados_tecnicos: '',
            cant_empleados_administrativos: '',
            galeria_socios: []
        },
        antecedentes: {
            fecha_lugar_origen: '',
            origen: '',
            forma_integracion: '',
            year_inicio: '',
            cant_socios_hombres_iniciales: '',
            cant_socios_mujeres_iniciales: '',
            cant_familias_iniciales: '',
            galeria_antecedentes: []
        },
        productos_servicios: {
            cant_socios_integrados: '',
            cant_socios_proveedores: '',
            proveedores_externos: '',
            certificados: [''],
            actividades_procesos: [],
            productos_servicios: [],
            galeria_actividades_procesos: [[]], // array con arrays con objetos File
            galeria_productos_servicios: [[]], // array con arrays con objetos File
        },
        contacto_comercial: {
            nombre_contacto: '',
            calle: '',
            numero_ext: '',
            numero_int: '',
            localidad: '',
            municipio: '',
            codigo_postal: '',
            estado: '',
            telefono: '',
            whatsapp: '',
            email: '',
            puntos_venta: [],
        },
        datos_publicador: {
            nombre: '',
            organizacion: '',
            email: '',
            telefono: '',
            whatsapp: '',
        }

    });
    const [errores, setErrores] = useState([]);
    // funcion para actualizar el estado datosFormulario
    /**
     * 
     * @param {*} e 
     * @param {boolean} imagen 
     */
    const setDatos = (e, imagen = null) => {
        let step = steps.filter((s) => s.id === paso);
        step = step[0].name;
        if (imagen) {
            setDatosFormulario({ ...datosFormulario, [step]: { ...datosFormulario[step], [e.target.name]: imagen } });
        } else {
            setDatosFormulario({ ...datosFormulario, [step]: { ...datosFormulario[step], [e.target.name]: e.target.value } });
        }
    }

    const construirFormData = (formData, datos, clavePadre = '') => {
        Object.keys(datos).forEach((clave) => {
            const claveCompleta = clavePadre ? `${clavePadre}[${clave}]` : clave;
            if (Array.isArray(datos[clave])) {
                datos[clave].forEach((item, index) => {
                    if (Array.isArray(item) && item[0] instanceof File) {
                        // Si es un array de arrays con objetos File, agrega cada elemento al FormData
                        item.forEach((file, subIndex) => {
                            formData.append(`${claveCompleta}[${index}][${subIndex}]`, file);
                        });
                    } else if (item instanceof File) {
                        // Si es un objeto File, agrega al FormData
                        formData.append(`${claveCompleta}[${index}]`, item);
                    } else {
                        // Si es un array no File o cualquier otra cosa, llama recursivamente
                        construirFormData(formData, { [clave]: item }, `${claveCompleta}[${index}]`);
                    }
                });
            } else if (typeof datos[clave] === 'object' && datos[clave] !== null) {
                // Si es un objeto, llama recursivamente
                construirFormData(formData, datos[clave], claveCompleta);
            } else {
                if (claveCompleta.includes("logotipo")) {
                    formData.append('datos_generales[logotipo]', datos);
                } else {
                    // Tratamiento directo para cualquier otra propiedad (incluyendo imágenes individuales)
                    formData.append(claveCompleta, datos[clave]);
                }
            }
        });
    };


    // para guardar los datos en la bd (una vez completos)
    const handleSubmit = async () => {
        var formData = new FormData();
        construirFormData(formData, datosFormulario);
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/agregar_empresa`, { method: 'POST', body: formData })
            .then((res) => res.json())
            .then(respuesta => {
                toast[respuesta.status](respuesta.message);
                if (respuesta.status === "success") {
                    setTimeout(() => {
                        navigate('/empresas');
                    }, 1000);
                }

            });
    }

    useEffect(() => { setErrores([]) }, [])

    const steps = [
        { id: 0, name: 'datos_generales', label: 'Datos Generales', action: <DatosGenerales datos={datosFormulario.datos_generales} setDatos={setDatos} errores={errores} /> },
        { id: 1, name: 'total_socios', label: 'Total de Socios', action: <TotalSocios datos={datosFormulario.total_socios} setDatos={setDatos} errores={errores} /> },
        { id: 2, name: 'antecedentes', label: 'Antecedentes', action: <Antecedentes datos={datosFormulario.antecedentes} setDatos={setDatos} errores={errores} /> },
        { id: 3, name: 'objetivos', label: 'Objetivos e impactos de la empresa', action: <Objetivos datos={datosFormulario.objetivos} setDatos={setDatos} errores={errores} /> },
        { id: 4, name: 'actividades_economicas', label: 'Actividades Económicas', action: <ActividadesEconomicas datos={datosFormulario.actividades_economicas} setDatos={setDatos} errores={errores} /> },
        { id: 5, name: 'productos_servicios', label: 'Productos y servicios', action: <ProductosServicios datos={datosFormulario.productos_servicios} setDatos={setDatos} errores={errores} /> },
        { id: 6, name: 'contacto_comercial', label: 'Contacto comercial', action: <ContactoComercial datos={datosFormulario.contacto_comercial} setDatos={setDatos} errores={errores} /> },
        { id: 7, name: 'datos_publicador', label: 'Datos del publicador', action: <DatosPublicador setCheck={setTerminos} datos={datosFormulario.datos_publicador} setDatos={setDatos} errores={errores} /> },
    ];

    const handleNextStep = () => {
        let validated = validar();
        if (validated.success) {
            setPaso(paso + 1);
        } else {
            //validated.messages.forEach((message) => {
            toast.error(validated.messages[0]);
            //})
            //console.log(errores);
        }
        window.scrollTo(0, 0);

    }

    const [open, setOpen] = useState(false);

    const validar = () => {
        let validated = true;
        let message = [];
        let errs;
        switch (paso) {
            case 0:
                errs = Object.keys(datosFormulario.datos_generales).map((label) => {
                    let valor;
                    switch (label) {
                        case 'nombre_empresa': case 'acronimo_empresa':
                        case 'figura_juridica_es': case 'nombre_contacto':
                        case 'calle': case 'numero_ext':
                        case 'codigo_postal': case 'localidad':
                        case 'municipio': case 'estado':
                            valor = datosFormulario.datos_generales[label];
                            if (!valor || ['', undefined, null].includes(valor)) {
                                validated = false;
                                message.push('Favor de llenar los campos obligatorios (*).')
                                return label;
                            }
                            break;
                        case 'email':
                            valor = datosFormulario.datos_generales[label];
                            if (!valor || !validarEmail(valor)) {
                                validated = false;
                                message.push('Por favor, ingresa un correo electrónico válido.')
                                return label
                            }
                            break;
                        case 'telefono':
                            valor = datosFormulario.datos_generales[label];
                            if (!valor || !validarTelefono(valor) || valor.length < 10 || isNaN(Number(valor))) {
                                validated = false;
                                message.push('Formato de teléfono incorrecto.');
                                return label
                            }
                            break;
                        case 'logotipo':
                            if (!(datosFormulario.datos_generales.logotipo instanceof File)) {
                                validated = false;
                                message.push('Es necesario agregar un logotipo.');
                                return label;
                            }
                            break;
                        case 'galeria':
                            if (datosFormulario.datos_generales.galeria.length < 1) {
                                message.push('Debe haber al menos una imágen de las instalaciones.');
                                validated = false;
                            }
                        default:
                            break;
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;
            case 1:
                errs = Object.keys(datosFormulario.total_socios).map((label) => {
                    switch (label) {
                        case 'galeria_socios': case 'cant_empleados_administrativos':
                            break;
                        default:
                            let v = datosFormulario.total_socios[label];
                            if (v.length < 1 || [null, '', undefined].includes(v)) {
                                validated = false;

                                return label;
                            }
                            break;
                    }
                });
                if (errs.length > 0) {
                    message.push("Es necesario llenar los campos obligatorios (*).");
                }
                setErrores(errs.filter((error) => error !== undefined));
                break;
            case 2:
                errs = Object.keys(datosFormulario.antecedentes).map((label) => {
                    switch (label) {
                        case 'forma_integracion': case 'galeria_antecedentes':
                            break;
                        default:
                            let v = datosFormulario.antecedentes[label];
                            if (v.length < 1 || [null, '', undefined].includes(v)) {
                                validated = false;

                                return label;
                            }
                            break;
                    }
                });
                if (errs.length > 0) {
                    message.push("Es necesario llenar los campos obligatorios (*).");
                }
                setErrores(errs.filter((error) => error !== undefined));
                break;
            case 3:

                break;
            case 4:
                errs = Object.keys(datosFormulario.actividades_economicas).map((label) => {
                    switch (label) {
                        case 'giro_actividad':
                            if (datosFormulario.actividades_economicas[label].length < 1) {
                                validated = false;
                                message.push('La empresa debe tener al menos un giro de actividades economicas.');
                            }
                            break;
                        case 'productos_servicios':
                            let productos = datosFormulario.actividades_economicas[label];
                            if (productos.length < 1) {
                                message.push('Es necesario agregar al menos un producto o servicio.');
                                validated = false;
                            } else {
                                // validar cada producto/servicio:
                                productos.forEach((producto) => {
                                    let allp = true
                                    Object.values(producto).map((dato) => {
                                        if ([null, '', undefined].includes(dato)) {
                                            allp = false;
                                            validated = false;
                                        }
                                        return;
                                    })
                                    if (!allp) {
                                        message.push('Es necesario llenar todos los campos.');
                                    }
                                });
                            }
                            break;
                        case 'unidades_produccion':
                            let unidades = datosFormulario.actividades_economicas[label];
                            if (unidades.length < 1) {
                                validated = false;
                                message.push('Es necesario agregar al menos una unidad de producción.');
                            } else {
                                unidades.forEach((unidad) => {
                                    let allu = true;
                                    Object.values(unidad).map((dato) => {
                                        if ([null, '', undefined].includes(dato)) {
                                            allu = false;
                                            validated = false;
                                        }
                                        return;
                                    })
                                    if (!allu) {
                                        message.push('Es necesario llenar todos los campos.');
                                    }
                                })
                            }
                            break;
                        default: break;
                    }
                });
                setErrores(errs.filter((error) => error !== undefined));
                break;
            case 5:
                errs = Object.keys(datosFormulario.productos_servicios).map((label) => {
                    switch (label) {
                        case 'actividades_procesos': case 'productos_servicios':
                            let actividades = datosFormulario.productos_servicios[label];
                            actividades.forEach((actividad) => {
                                if (actividad.descripcion.length < 1 || [null, '', undefined].includes(actividad.descripcion)) {
                                    validated = false;
                                    return label;
                                }
                            });
                            break;
                        case 'cant_socios_proveedores': case 'cant_socios_integrados': case 'proveedores_externos':
                            let v = datosFormulario.productos_servicios[label];
                            if (v.length < 1 || [null, '', undefined].includes(v)) {
                                validated = false;
                                return label;
                            }
                            break;
                        default:
                            break;
                    }
                });
                if (errs.length > 0) {
                    message.push("Es necesario llenar los campos obligatorios (*).");
                }
                setErrores(errs.filter((error) => error !== undefined));
                break;
            case 6:
                errs = Object.keys(datosFormulario.contacto_comercial).map((label) => {
                    switch (label) {
                        case 'numero_int': case 'whatsapp':
                            break;
                        case 'telefono':
                            if (!validarTelefono(datosFormulario.contacto_comercial[label])) {
                                message.push("Número de teléfono inválido.");
                                validated = false;
                                return label;
                            }
                            break;
                        case 'email':
                            if (!validarEmail(datosFormulario.contacto_comercial[label])) {
                                message.push("Formato de correo electrónico incorrecto.");
                                validated = false;
                                return label;
                            }
                            break;
                        case 'puntos_venta':
                            // array con campos   
                            if (datosFormulario.contacto_comercial[label].length == 0) {
                                validated = false;
                                message.push("Es necesario agregar al menos un Punto de venta y/o distribuidores");
                                return label;
                            } else {
                                datosFormulario.contacto_comercial[label].forEach((punto) => {
                                    let keys = Object.keys(punto);
                                    keys.forEach((key) => {
                                        switch (key) {
                                            case 'numero_int': case 'whatsapp':
                                                break;
                                            case 'telefono':
                                                if (!validarTelefono(punto[key])) {
                                                    message.push("Número de teléfono inválido.");
                                                    validated = false
                                                    return key;
                                                }
                                                break;
                                            case 'email':
                                                if (!validarEmail(punto[key])) {
                                                    message.push("Ingresa un correo electrónico válido.");
                                                    validated = false
                                                    return key;
                                                }
                                                break;
                                            default:
                                                if ([null, undefined, ''].includes(punto[key])) {
                                                    validated = false
                                                    return key;
                                                }
                                        }
                                    })
                                });
                            }
                            break;
                        default:
                            let v = datosFormulario.contacto_comercial[label];
                            if (v.length < 1 || [null, '', undefined].includes(v)) {
                                validated = false;
                                return label;
                            }
                            break;
                    }
                });
                if (!errs.includes("telefono") && !errs.includes("email") && errs.length > 0) {
                    message.push("Es necesario llenar los campos obligatorios (*).");
                }
                setErrores(errs.filter((error) => error !== undefined));
                break;
            case 7:
                // Se necesita al menos nombre y correo para enviar el token
                errs = Object.keys(datosFormulario.datos_publicador).map((label) => {
                    switch (label) {
                        case 'nombre':
                            if ([null, undefined, ''].includes(datosFormulario.datos_publicador[label])) {
                                validated = false
                                return label;
                            }
                            break;
                        case 'email':
                            if (!validarEmail(datosFormulario.datos_publicador[label])) {
                                message.push("Formato de correo electrónico incorrecto.");
                                validated = false;
                                return label;
                            }
                            break;
                        default:
                            break;
                    }
                });
                errs = errs.filter((error) => error !== undefined);

                if (!errs.includes("email") && errs.length > 0) {
                    message.push("Es necesario llenar los campos obligatorios (*).");
                } else if (errs.includes('email') && errs.length === 1) {
                    // abrir modal para solicitar correo
                    setOpen(true);
                }
                setErrores(errs);
                break;
            default:
                break;
        }
        return { success: validated, messages: message };
    }

    const validarPublicador = () => {
        let mail = datosFormulario.datos_publicador.email;
        if (['', null, undefined].includes(mail) || !validarEmail(mail)) {
            toast.error("Formato de correo electrónico incorrecto");
        } else {
            setOpen(false);
            setPaso(paso + 1);
        }
    }

    useEffect(() => console.log(datosFormulario), [datosFormulario]);

    return (
        <Box sx={{ mx: 'auto', mt: 0, width: '100%' }}>

            {/* Formulario */}
            <CardHeader title={<Typography textAlign='center' variant='h5'>
                Nuevo perfil de empresa
                <Paper
                    square
                    elevation={0}
                    sx={{
                        display: { lg: 'none', xs: 'flex' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 50,
                        bgcolor: 'background.default',
                    }}
                >
                    <Typography textAlign='center' fontWeight='bold' color="primary" variant="h6">- {paso !== steps.length ? steps[paso].label : 'Registrar Empresa'} -</Typography>
                </Paper>
            </Typography>} />
            <Divider />
            <CardContent>
                {/* Stepper PC */}
                <Box sx={{ mt: 2, mb: 4, display: { xs: 'none', lg: 'block' } }}>
                    <Stepper activeStep={paso} orientation='horizontal'>
                        {steps.map((step, index) => {
                            return (
                                <Step key={step.label}>
                                    <StepLabel sx={{ '& :hover': { cursor: 'auto' } }} onClick={() => { }}>{step.label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Box>
                {/* Pasos Movil */}

                <Grid spacing={1} container>
                    <Grid item md>
                        {paso === steps.length ? (
                            <Box sx={{ mx: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <CheckCircle sx={{ fontSize: 100, color: '#a9f07f' }} />
                                </Box>
                                <Typography textAlign='center' variant="h6" sx={{ mt: 2, mb: 1 }}>
                                    <strong>¡Haz llegado al final!</strong><br />
                                    Si los datos son correctos, por favor haga clic en el botón para guardar el perfil de empresa.
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ mx: 2 }}>
                                {steps[paso].action}
                            </Box>
                        )}
                    </Grid>

                </Grid>
            </CardContent>
            {/* Navegacion pc */}

            <CardActions sx={{ display: { lg: 'flex', xs: 'none' }, justifyContent: 'space-around', my: 2 }}>
                {
                    paso !== steps.length ?
                        <React.Fragment>
                            <Button size='large' disabled={paso === 0} variant='contained' color="primary" onClick={() => setPaso(paso - 1)}>
                                Anterior
                            </Button>
                            {paso < steps.length - 1 &&
                                <Button disabled={paso === steps.length - 1 && !terminos} size='large' variant='contained' color="success" onClick={() => {
                                    let v = validar();
                                    if (v.success) {
                                        setPaso(steps.length - 1);
                                    } else {
                                        toast.error(v.messages[0]);
                                    }
                                }}>
                                    Guardar empresa
                                </Button>
                            }
                            <Button disabled={paso === steps.length - 1 && !terminos} size='large' variant='contained' color="success" onClick={handleNextStep}>
                                Siguiente
                            </Button>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Button size='large' variant='contained' color="primary" onClick={() => setPaso(paso - 1)}>
                                Anterior
                            </Button>
                            <Button size="large" color="success" variant="contained" onClick={handleSubmit}>GUARDAR EMPRESA</Button>
                        </React.Fragment>
                }
            </CardActions>
            {/* Stepper movil */}
            <Box sx={{ display: { lg: 'none', sx: 'block' } }}>
                <MobileStepper
                    variant="dots"
                    steps={steps.length}
                    position="bottom"
                    activeStep={paso}
                    backButton={
                        <Button size="small" onClick={() => setPaso(paso - 1)} disabled={paso === 0}>
                            <KeyboardArrowLeft />
                            Anterior
                        </Button>
                    }
                    nextButton={
                        <Button
                            size="small"
                            onClick={() => {
                                if (paso === steps.length) {
                                    handleSubmit();
                                } else {
                                    handleNextStep();
                                }
                            }
                            }
                            disabled={paso === steps.length - 1 && !terminos}
                            color={paso === steps.length ? 'success' : 'primary'}
                        >
                            {paso === steps.length ? 'Guardar' : 'Siguiente'}
                            <KeyboardArrowRight />
                        </Button>
                    }
                />

            </Box>

            {/* Modal para agregar correo electronico del usuario que publica */}
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>
                    <Typography variant="h5">
                        Agregar correo electrónico
                    </Typography>
                </DialogTitle>
                <Box sx={{ mx: 4 }}>
                    <Typography>Para poder editar este registro, necesitarás tu correo electrónico</Typography>
                    <TextField name="email" value={datosFormulario.datos_publicador.email} onChange={setDatos} sx={{ my: 2 }} fullWidth label="Correo electrónico" />
                </Box>
                <DialogActions>
                    <Button color="success" variant="contained" onClick={validarPublicador}>Guardar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default AgregarEmpresa